export default __webpack_public_path__ + "static/media/Logo_Castle_Rock.54cfdef1.png";